export default "__VITE_ASSET__DjUipNN___"